import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterModule} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
    imports: [
        RouterModule,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinksComponent {}
